<template>
    <v-dialog title="提示" v-if="show" v-model="show" @input="change" size="md"
              :show-close="true">
        <div class="tehui-line">
            您创建的deal已经满足特惠票的需求，请问您是否需要申请特惠票
        </div>
        <div class="tehui-line">
            <strong style="font-size: 16px;">申请时间：</strong>
            <span data-date-ranger>
                 <v-datepicker  :message='dateBeginEnd'
                                :options='inDateOption'></v-datepicker>
            </span>
            <div class="red" style="font-size: 12px; color:red">
                特惠票涉及大量资源位置，目前仅开放1月内申请，超出时间后可继续申请
            </div>
        </div>
        <div class="tehui-line">
            <input type="checkbox" :true-value="1" :false-value="0" v-model="query.isMtRecommend">同时申请美团推荐
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary" @click="save()">保存</button>
            <button class="btn" type="button" @click="cancel()">取消</button>
        </div>
    </v-dialog>
</template>
<script>
    import { formatDate } from 'helpers'
    import { tehuiApply } from 'api/ticket'
    export default {
        data () {
            return {
                dateBeginEnd: '',
                query: {
                    startTime: null,
                    endTime: null,
                    isMtRecommend: 1
                },
                inDateOption: {
                    allowInput: false,
                    mode: 'range',
                    onChange: (dates) => {
                        dates = dates.length ? dates : this.dateBeginEnd.split(' ~ ')
                        if (dates && dates.length) {
                            this.query.startTime = formatDate(dates[0], 'yyyy-MM-dd')
                            this.query.endTime = formatDate(dates[1], 'yyyy-MM-dd')
                        }
                    }
                }
            }
        },
        props: {
            options: {
                'default': null
            },
            show: {
                require: true,
                'default': false
            }
        },
        methods: {
            save() {
                if (!this.query.startTime || !this.query.endTime) {
                    this.$message('请选择日期范围！');
                    return;
                }
                tehuiApply({
                    startTime: this.query.startTime,
                    endTime: this.query.endTime,
                    dealId: this.options.dealId,
                    isMtRecommend: this.query.isMtRecommend
                }).then((json) => {
                    this.$notify({
                        title: '提示',
                        message: '特惠票申请成功',
                        type: 'success'
                    })
                    this.show = false
                    this.$emit('teHuiApplyFinish', 'success')
                    this.options = null
                }, (res) => {
                    this.$emit('teHuiApplyFinish', 'fail')
                    this.$notify({
                        title: '提示',
                        message: res && res.message || '特惠申请失败',
                        type: 'error'
                    })
                })
            },
            cancel () {
                this.$emit('teHuiApplyFinish', 'cancel')
                this.show = false
                this.options = null
                this.query.startTime = this.query.endTime = null
            },
            change (open) {
                if (!open) {
                    this.cancel()
                }
            }
        },
        watch: {
            dateBeginEnd (value) {
                let dates = value.split('~')
                if (dates.length) {
                    this.startTime = dates[0]
                    this.endTime = dates[1]
                }
            },
            options() {
                if (this.options && this.options.dealId) {
                    if (this.options.startTime) {
                        this.inDateOption.minDate = this.options.startTime
                    }
                    if (this.options.endTime) {
                        this.inDateOption.maxDate = this.options.endTime
                    }
                }
            }
        },
        mounted () {
            if (this.options && this.options.dealId) {
                if (this.options.startTime) {
                    this.inDateOption.minDate = this.options.startTime
                }
                if (this.options.endTime) {
                    this.inDateOption.maxDate = this.options.endTime
                }
            }
        }
    }
</script>

<style rel="stylesheet/css" lang="postcss" scoped type="text/postcss">
    .tehui-line{
        margin-bottom: 10px;
    }

</style>



// WEBPACK FOOTER //
// teHuiApply.vue?2f4fac82